<footer class="skv-footer">
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-5">
                <div class="skv-footer__header-container">
                    <img class="skv-footer__logo" src="/assets/img/skolverket-logotype-white.svg" alt="Skolverket" />
                    <div class="skv-footer__description text-standard">Skolverket arbetar för att alla barn, ungdomar och vuxna ska få en utbildning av god kvalitet.</div>
                </div>
            </div>
            <div class="col-12 col-lg-7">
                <div class="skv-footer__navigation-container">
                    <ul class="skv-footer__navigation">
                        <li class="skv-footer__navigation-item">
                            <a class="skv-nav-link skv-nav-link--light" href="https://skolverket.se/om-oss">
                                Om Skolverket
                                <svg focusable="false" class="skv-icon skv-icon--inline">
                                    <use xlink:href="#icon-chevron-right"></use>
                                </svg>
                            </a>

                        </li>
                        <li class="skv-footer__navigation-item">
                            <a class="skv-nav-link skv-nav-link--light" href="https://www.skolverket.se/om-oss/webbplatser-och-sociala-kanaler/skolverkets-webbplatser">
                                Våra webbplatser
                                <svg focusable="false" class="skv-icon skv-icon--inline">
                                    <use xlink:href="#icon-chevron-right"></use>
                                </svg>
                            </a>

                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</footer>